import {message} from 'antd'
import {getId, getType} from 'apis/model/base'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import {useHistory} from 'modules/navigation/useRouter'
import {permissionCodes} from 'modules/permissions/contants'
import React, {useCallback, useContext, useEffect, useMemo, useState,} from 'react'
import {compose} from 'recompose'
import {ModalLayout} from 'routes/createRequiredLogin'
import {staticPaths} from 'routes/staticPaths'
import {NullAsDefault, renderElse, renderIf} from 'views/Shared'
import {Queries} from 'views/Shared/enums/Queries'
import {withAccessPermissions} from './composers'
import {modalWidth, ModuleContext} from './configs'
import ActionMenu from './custom/ActionMenu'
import {AppEntities, fromAppEntity} from './enums'
import {ContextActionTypes} from './factory/createContextMenu'
import {ExporterLoader} from './factory/createDataExporter'
import gModel from './gModel'
import {ImporterLoader} from "./factory/createDataImporter";
import {getRouteSearchParams, useRouteSearchParam} from "../../envs/_current/history";
import {usePromoFunc} from "../Shared/functions/usePromoFunc";
import {PiGearSix} from "react-icons/pi";
import {TbWorld, TbWorldOff} from "react-icons/tb";
import {LoginContext} from "components/LoginContext";
import useAsyncAction from "modules/asyncCache/useAsyncAction";
import {course_setPublicByServer_Api} from "apis";
import {notifyOnError} from "./factory/createErrorEvent";
import {NotificationActionTypes, successNotify} from "./factory/createNotification";

export const useData = ({item}) => {
    const history = useHistory()

    const [action, setAction] = useState({
        type: undefined,
        value: undefined,
    })

    const [id, type] = [getId(item), getType(item)]

    const searchParams = getRouteSearchParams()

    const action_query = useRouteSearchParam(Queries.ACTION)

    const type_query = useRouteSearchParam(Queries.TYPE)

    useEffect(() => {
        setAction({
            type: type_query,
            value: getId(item),
        })
    }, [history.location])

    const onCancel = () => {
        setAction({})
        searchParams.delete(Queries.TYPE)
        searchParams.delete(Queries.ACTION)
        history.replace({
            search: '?' + searchParams.toString(),
            hash: _.get(history, 'location.hash'),
        })
    }

    const onImport = (query_type = type) => {
        searchParams.set(Queries.ACTION, 'import')
        searchParams.set(Queries.TYPE, query_type)
        history.replace({
            search: '?' + searchParams.toString(),
            hash: _.get(history, 'location.hash'),
            state: {
                id,
                type: query_type,
                isModal: true,
            },
        })
    }

    const onExport = (query_type = type) => {
        searchParams.set(Queries.ACTION, 'export')
        searchParams.set(Queries.TYPE, query_type)
        history.replace({
            search: '?' + searchParams.toString(),
            hash: _.get(history, 'location.hash'),
            state: {
                id,
                type: query_type,
                isModal: true,
            },
        })
    }

    const modal_content = useMemo(() => {
        const {value, type} = action;
        let body = null
        if (action_query === 'import') {
            body = (
                <ImporterLoader
                    id={value}
                    type={type}
                    onCancel={onCancel}
                />
            )
        } else if (action_query === 'export') {
            body = (
                <ExporterLoader
                    id={value}
                    type={type}
                />
            )
        }
        return (
            [
                AppEntities.EXAMINATION,
                "COURSE_STUDENT_EXPORT", "COURSE_ATTENDANCE_EXPORT", "COURSE_GRADE_EXPORT",
                "COURSE_STUDENT_IMPORT", "COURSE_ATTENDANCE_IMPORT", "COURSE_GRADE_IMPORT"
            ].includes(action.type) && (
                <ModalLayout
                    footer={null}
                    onCancel={onCancel}
                    maskClosable={false}
                    open={action.type && action_query}
                    width={modalWidth.small}
                    title={renderElse(
                        _.isEmpty(action_query),
                        <Translate>
                            {(t) => (
                                <div className="flex gap-2 flex-center font-bold uppercase">
                                    {t(action_query)}
                                </div>
                            )}
                        </Translate>
                    )}>
                    {body}
                </ModalLayout>
            )
        )
    }, [searchParams, action_query, action])

    return [
        modal_content,
        {
            onImport,
            onExport,
            searchParams,
            action_query,
            current_action: action,
        },
    ]
}

const AdminPanel = ({
                        Wrapper = 'div',
                        goToSetting = ({path, push = NullAsDefault}) => {
                            push(path)
                        },
                    }) => {
    const t = useTranslate()

    const history = useHistory()

    const {value} = useContext(ModuleContext)

    const {entity, Context} = value

    const currentContext = useContext(Context)

    const {actions} = _.get(value, 'settings') || {}

    const {contextName} = fromAppEntity(entity)

    const item = _.get(currentContext, contextName)

    const withOwnerQueries = (owner, params = {}) => {
        if (_.isEmpty(owner)) {
            return undefined
        }
        let searchParams = new URLSearchParams({
            owner_id: getId(owner),
            owner_type: getType(owner),
            ...params,
        })
        return `?${searchParams.toString()}`
    }

    const [modalIO, {onExport = NullAsDefault, onImport = NullAsDefault}] = useData({item})
    const {onAddToRecommendation, onRemoveFromRecommendation} = usePromoFunc({})

    const handleClick = useCallback(
        (action) => {
            const _searchQueries = withOwnerQueries(item)
            const [id, type] = [getId(item), getType(item)]
            switch (action) {
                case ContextActionTypes.EXPORT:
                    if ([AppEntities.EXAMINATION].includes(type)) {
                        onExport()
                    } else {
                        message.warn('coming soon')
                    }
                    break
                case "COURSE_ATTENDANCE_EXPORT":
                case "COURSE_GRADE_EXPORT":
                case "COURSE_STUDENT_EXPORT":
                    onExport(action)
                    break
                case "COURSE_ATTENDANCE_IMPORT":
                case "COURSE_GRADE_IMPORT":
                case "COURSE_STUDENT_IMPORT":
                    onImport(action)
                    break
                case ContextActionTypes.SETTINGS:
                    goToSetting({
                        push: history.push,
                        path: gModel.getLinkToSetting(item),
                    })
                    break
                case ContextActionTypes.CREATE_CHANNEL:
                    history.push({
                        pathname: staticPaths.createChannel.pathname,
                        search: _searchQueries,
                        state: {
                            isModal: true,
                        },
                    })
                    break
                case ContextActionTypes.CREATE_EVENT:
                    history.push({
                        pathname: staticPaths.createEvent.pathname,
                        search: _searchQueries,
                        state: {
                            isModal: true,
                        },
                    })
                    break
                case ContextActionTypes.CREATE_ORGANIZATION:
                    history.push(staticPaths.createOrganization)
                    break
                case ContextActionTypes.ADD_TO_RECOMMENDATION:
                    onAddToRecommendation({owner_type: getType(item), owner_id: getId(item)})
                    break
                case ContextActionTypes.REMOVE_FROM_RECOMMENDATION:
                    onRemoveFromRecommendation({owner_type: getType(item), owner_id: getId(item)})
                    break
                default:
                    message.warning(
                        <span>
              <span className="font-bold">{'Admin panel'}</span>
              <span>{' missing action handler'}</span>
            </span>
                    )
                    break
            }
        },
        [item, history]
    )

    if (_.isEmpty(value)) return null

    return (
        <Wrapper className="my-3 px-3 py-1 flex items-center bg-gray-300 rounded-md">
            <span className="flex-1 font-semibold text-gray-700 capitalize">
                {t('administration panel')}
            </span>
            {!_.isEmpty(actions) && (
                <ActionMenu
                    actions={actions}
                    onClick={handleClick}
                />
            )}
            {modalIO ? modalIO : null}
        </Wrapper>
    )
}

export const ActionPanel = ({
                                item,
                                title = 'administration panel',
                                actions = [
                                    {
                                        key: ContextActionTypes.SETTINGS,
                                        label: 'setting',
                                        icon: <PiGearSix size={15} className="text-color-400"/>,
                                    },
                                ],
                            }) => {
    const t = useTranslate()
    const {onAddToRecommendation, onRemoveFromRecommendation} = usePromoFunc({})

    const history = useHistory()

    const login = useContext(LoginContext)
    const {edit_system = false} = login ?? {}

    const onError = notifyOnError(t)
    const {handleAsyncAction: onSetPublicByServer} = useAsyncAction({
        onError,
        apiInfo: course_setPublicByServer_Api,
        onSuccess: () => successNotify(NotificationActionTypes.UPDATE, t),
    })

    const handleClick = (action) => {
        const [id, type] = [getId(item), getType(item)]
        switch (action) {
            case ContextActionTypes.SETTINGS:
                history.push(gModel.getLinkToSetting(item))
                break
            case ContextActionTypes.EXPORT:
                if ([AppEntities.EXAMINATION].includes(type)) {
                    onExport()
                } else {
                    message.warn('coming soon')
                }
                break
            case "COURSE_ATTENDANCE_EXPORT":
            case "COURSE_GRADE_EXPORT":
            case "COURSE_STUDENT_EXPORT":
                onExport(action)
                break
            case "COURSE_ATTENDANCE_IMPORT":
            case "COURSE_GRADE_IMPORT":
            case "COURSE_STUDENT_IMPORT":
                onImport(action)
                break
            case 'ADD_TO_RECOMMENDATION':
                onAddToRecommendation({owner_type: type, owner_id: id})
                break
            case 'REMOVE_FROM_RECOMMENDATION':
                onRemoveFromRecommendation({owner_type: type, owner_id: id})
                break
            case 'SET_PUBLIC_BY_SERVER':
                onSetPublicByServer({value: item?.public_by_server ? 0 : 1}, {type, id})
                break
            default:
                break
        }
    }

    const [modalIO, {onExport = NullAsDefault, onImport = NullAsDefault}] = useData({item})

    // public_by_server - lớp override hiển thị TOÀN HỆ THỐNG ở danh sách tra cứu, CHỈ system admin
    // (edit_system) mới thấy hành động này, và chỉ với entity thực sự có cột này (BE có trả field -
    // xem CourseTransformer.php/CourseTransformerBasic.php). 1 mục duy nhất, đổi label/icon theo
    // trạng thái hiện tại (rõ ràng hơn cặp Bật/Tắt luôn hiện song song như ADD/REMOVE_TO_RECOMMENDATION
    // ở trên - tránh bấm nhầm chiều).
    const hasPublicByServerField = !_.isNil(item?.public_by_server)
    const visibilityActions = (edit_system && hasPublicByServerField) ? [
        item?.public_by_server ? {
            key: 'SET_PUBLIC_BY_SERVER',
            label: 'hide from system-wide search',
            icon: <TbWorldOff size={15} className="text-color-400"/>,
        } : {
            key: 'SET_PUBLIC_BY_SERVER',
            label: 'show in system-wide search',
            icon: <TbWorld size={15} className="text-color-400"/>,
        },
    ] : []

    const allActions = [...(actions ?? []), ...visibilityActions]

    return renderIf(
        item?.edit,
        <div className="my-3 px-3 py-1 flex items-center bg-gray-300 rounded-md">
            <span className="flex-1 font-semibold text-gray-700 capitalize">
                {t(title)}
            </span>
            {!_.isEmpty(allActions) && (
                <ActionMenu
                    actions={allActions}
                    onClick={handleClick}
                />
            )}
            {modalIO ? modalIO : null}
        </div>
    )
}

export default compose(withAccessPermissions([permissionCodes.canEdit], NullAsDefault))(
    AdminPanel
)
